// extracted by mini-css-extract-plugin
export var active = "ComponentsSlider-module--active--57a8d";
export var desktopOnly = "ComponentsSlider-module--desktopOnly--ba990";
export var hide = "ComponentsSlider-module--hide--d4178";
export var navigationButton = "ComponentsSlider-module--navigationButton--2b804";
export var navigationButtonIcon = "ComponentsSlider-module--navigationButtonIcon--28031";
export var navigationButtonNext = "ComponentsSlider-module--navigationButtonNext--3f0e9";
export var navigationButtonPrev = "ComponentsSlider-module--navigationButtonPrev--95804";
export var paddingForNavigationButton = "ComponentsSlider-module--paddingForNavigationButton--410c6";
export var pagination = "ComponentsSlider-module--pagination--4398f";
export var slideImage = "ComponentsSlider-module--slideImage--03d0b";
export var slideLabelMessage = "ComponentsSlider-module--slideLabelMessage--d9478";
export var sliderContainer = "ComponentsSlider-module--sliderContainer--a3f4b";
export var swiper = "ComponentsSlider-module--swiper--f1fa8";
export var swiperPadding = "ComponentsSlider-module--swiperPadding--e6f7d";
export var swiperSlide = "ComponentsSlider-module--swiperSlide--64220";